export * from './modify-room.component';



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/modify-room/index.ts